import React, {useEffect, useState} from 'react';
import {WdiGridApp} from '@/components/WdiBus/PanelForWarning';
import {FormSa} from '@/services/sales/sa';
import {wdiCore} from '@/components/GridWidget';
import {Enum} from '@/enums/system';
import {Empty} from "antd";
import {ColumnsType} from "antd/lib/table";

const SaBudgetSubmit: Record<string, any> = {
  boId: (_: any, record: any) => {
    return record['boName'];
  },
  productLineId: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productLineCode'], record['productLineName']);
  },
  ecId: (_: any, record: any) => {
    if (record['budgetControlType'] == Enum.BudGetControlType.SPECIAL) {
      return <span style={{color: "#ff0000"}}>{record['ecName']}</span>;
    } else {
      return <span>{record['ecName']}</span>;
    }
  },
  ym: (_: any, record: any) => {
    return record['ym'];
  },
  amountRemain: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    if (record['amount'] > record['amountRemain']) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amount'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  rowNumbers: (_: any, record: any) => {
    return record['rowNumbers'];
  },
  productId: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productCode'], record['productName']);
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountApproved: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproved'], 2);
  },
};
const SaBudget: Record<string, any> = {
  boId: (_: any, record: any) => {
    return record['boName'];
  },
  productLineId: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productLineCode'], record['productLineName']);
  },
  ecId: (_: any, record: any) => {
    if (record['budgetControlType'] == Enum.BudGetControlType.SPECIAL) {
      return <span style={{color: "#ff0000"}}>{record['ecName']}</span>;
    } else {
      return <span>{record['ecName']}</span>;
    }
  },
  ym: (_: any, record: any) => {
    return record['ym'];
  },
  amountRemain: (_: any, record: any) => {
    if (record['amountRemain'] < 0) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amountRemain'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  rowNumbers: (_: any, record: any) => {
    return record['rowNumbers'];
  },
  productId: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productCode'], record['productName']);
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountApproved: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproved'], 2);
  },
};

const columnsRenders: Record<string, Record<string, any>> = {
  SaBudgetSubmit: SaBudgetSubmit,
  SaBudget: SaBudget,

};
const BudgetInformation: React.FC<{ formId?: number }> = (props) => {
  const [budgetInfos, setBudgetInfos] = useState<API.WdiPanelList>();
  const [budgetCount, setBudgetCount] = useState<number>(-1);

  useEffect(() => {
    if (props.formId) {
      FormSa.Buttons.budgetInfos(props.formId).then((response) => {
        setBudgetInfos(response.data);
        if (response.data && response.data.items) {
          setBudgetCount(response.data.items.length);
        } else {
          setBudgetCount(0);
        }
      });
    }
  }, [props.formId]);

  const renderWdiGridApp = (grid: API.WdiGrid) => {
    const columns: ColumnsType<any> = [];
    const columnsRender = columnsRenders[grid.key];
    grid.wdiColumns.map((wdiColumn) => {
      if (!wdiColumn.isHidden) {
        const column: any = {
          title: wdiColumn.displayName,
          dataIndex: wdiColumn.name,
          width: wdiColumn.width,
          ellipsis: true,
        };
        if (columnsRender && columnsRender[wdiColumn.name]) {
          column.render = columnsRender[wdiColumn.name];
        }
        columns.push(column);
      }
    });

    return (
      <WdiGridApp
        key={grid.key}
        wdiGrid={grid}
        columns={columns}
        dataSource={grid.items}
      />
    );
  };
  return (
    <>
      {budgetInfos?.items?.map((item) => {
        return (
          renderWdiGridApp(item)
        );
      })}
      {budgetCount === 0 &&
        <div>
          <div style={{ marginTop: "200px", textAlign: "center" }}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="没有预算信息" />
          </div>
        </div>
      }
    </>
  );
};

export default BudgetInformation;
